import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CroppingPageComponent} from './components/cropping-page/cropping-page.component';
import {CroppingRoutingModule} from './cropping-routing.module';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {InspectPageRoutingModule} from '../inspect/inspect-routing.module';
import {HttpClientModule} from '@angular/common/http';
import {GraphqlModule} from '../services/graphql-service/graphql.module';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {SharedModule} from '../shared/shared.module';
import {NgSelectModule} from '@ng-select/ng-select';
import {AngularSplitModule} from 'angular-split';
import {BadgeModule} from 'primeng/badge';
import {SelectContentComponent} from './components/select-content/select-content.component';
import {PoleDetailsComponent} from './components/pole-details/pole-details.component';
import {InspectionService} from '../inspect/services/inspection-service/inspection.service';
import {MessageService} from 'primeng/api';

@NgModule({
    declarations: [
        CroppingPageComponent,
        SelectContentComponent,
        PoleDetailsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CroppingRoutingModule,
        SharedModule,
        HttpClientModule,
        // TooltipModule.forRoot(MyDefaultTooltipOptions as TooltipOptions),
        GraphqlModule,
        VirtualScrollerModule,
        NgSelectModule,
        AngularSplitModule,
        BadgeModule
    ],
    providers: [
        InspectionService,
        MessageService
    ],
})
export class CroppingModule {
}
